import axios from '../api/axiosSettings.js';
import useAuth from "./useAuth.js";

const useLogout = () => {
    const { setAuth } = useAuth();

    const logout = async () => {
        setAuth({});
        console.log("AXIOS log out  : ");
        var finalIP = "";

        finalIP = "https://stepupkorea.kr/api/auth/logout";
        try {
            const response = await axios.post(finalIP, {
                withCredentials: true,
                credentials: 'include'
            });
            
        } catch (err) {
            console.error(err);
        }
    }

    return logout;
}

export default useLogout